import React from 'react';
import { EyeOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';

import AvatarStatus from 'componentsv2/AvatarStatus/AvatarStatus';

export const getColumns = showUserProfile => [
  {
    title: '# de Jugador',
    sorter: (a, b) => a?.number - b?.number,
    render: (_, record) => (record?.number ? `${record?.number}` : 'Sin número'),
  },
  {
    title: 'Miembros',
    dataIndex: 'name',
    render: (_, record) => (
      <div className="d-flex">
        <AvatarStatus
          src={record?.club_member.user.avatar_url}
          name={`${record?.club_member.user.first_name} ${record?.club_member.user.last_name}`}
        />
      </div>
    ),
    sorter: {
      compare: (a, b) => {
        a = a.club_member.user.first_name.toLowerCase();
        b = b.club_member.user.first_name.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: 'Correo Electrónico',
    dataIndex: ['user', 'email'],
    render: (_, record) => record?.club_member.user.email,
    sorter: {
      compare: (a, b) => {
        a = a.club_member.user.email.toLowerCase();
        b = b.club_member.user.email.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: 'Nombre de Usuario',
    dataIndex: ['user', 'user_name'],
    render: (_, record) => record?.club_member.user.user_name,
    sorter: {
      compare: (a, b) => {
        a = a.club_member.user.user_name.toLowerCase();
        b = b.club_member.user.user_name.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: '',
    dataIndex: 'actions',
    render: (_, record) => (
      <div className="text-right">
        <Tooltip title="View">
          <Button
            type="primary"
            className="mr-2"
            icon={<EyeOutlined />}
            onClick={() => {
              showUserProfile(record?.club_member);
            }}
            size="small"
          />
        </Tooltip>
      </div>
    ),
  },
];
